/**
 * @copyright Copyright (c) 2020, KNE GmbH.
 *
 * @author Jan Duwe <jan.duwe@kne.de>
 *
 * @license AGPL-3.0
 *
 * This code is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License, version 3,
 * as published by the Free Software Foundation.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License, version 3,
 * along with this program.  If not, see <http://www.gnu.org/licenses/>
 *
 */

import { IUser } from '../model/UserState'

export enum ManifestFileFormatType {
  Xml = 0,
  Json = 1
}

export interface IProduct {
    id: number;
    name: string;
    releaseDate: Date;
    description: string;
    userId: number;
    buildServerUri?: string;
    buildServerUserName?: string;
    buildServerPassword?: string;
    buildServerProjectName?: string;
    buildServerBuildType?: string;
    versions: IVersion[];
}

export interface IVersion {
    id: number;
    name: string;
    number: string;
    releaseDate: Date;
    description: string;
    applicationId: string;
    userId: number;
    patches: IPatch[];
}

export interface IPatch {
    id: number;
    name: string;
    number: string;
    releaseDate: Date;
    description: string;
    changeLog: string;
    mandatoryPatch: boolean;
    fileName: string;
    manifestId: string;
    versionId: number;
    userId: number;
    releasedEnvironments: number[];
}

export interface IAddPatchRequest {
    name: string;
    number: string;
    description: string;
    changeLog: string;
    mandatoryPatch: boolean;
    versionId: number;
    userId: number;
}

export interface IReleasePatchRequest {
    patchId: number;
    environmentIds: number[];
}

export interface IAddVersionRequest {
  name: string;
  number: string;
  description: string;
  applicationId: string;
  productId: number;
  userId: number;
  formatType: ManifestFileFormatType;
}

export interface IEditVersionRequest{
    id: number;
    name: string;
    number: string;
    description: string;
}

export interface IDeleteVersionRequest{
    id: number;
}


export interface IEditProductRequest {
    id: number;
    name: string;
    description: string;
    buildServerUri?: string;
    buildServerUserName?: string;
    buildServerPassword?: string;
    buildServerProjectName?: string;
    buildServerBuildType?: string;
}

export interface IProductsState {
    products: IProduct[];
}

export interface IPatchIdRequest{
    patchId: number;
}